<template lang="pug">
  div(class="content")
    div(class="md-layout md-gutter md-alignment-center-center")
      div(class="custom-div md-layout-item md-size-40 md-medium-size-55 md-xsmall-size-100")
        md-card
          md-card-header(data-background-color="green")
            h4(class="title") Membership Confirmation
          md-card-content
            div(class="md-layout" style="text-align: center")
              div(v-if="loading" style="margin: 10% 40%;")
                loading
              h4(v-if="success") You are now a paid USIT member! Thank you for joining us and we hope you have a great experience as a member.
                br
                router-link(to='/signin') Log in now.
              h4(v-if="success === false") Sorry, there was an error confirming your purchase. Please try again! For support, please contact technology@usiteam.org.
</template>

<script>
import axios from 'axios';

export default {
    data() {
      return{
        success: null,
        loading: true,
      };
    },
    created() {
      axios.get(`/api/confirm_purchase/${this.$route.params.token}`)
      .then((response) => {
        this.loading = false;
        if(response.data.error){
            this.success = false;
        } else {
            this.success = true;
        }
      }).catch((err) => {
        this.loading = false;
        this.success = false;
      });
    },
}
</script>

<style scoped>
  .custom-div{
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/ConfirmPurchase.vue